import type { RefObject } from 'react';
import type { ViewInstance } from 'react-native';

/**
 * Scrolls the element into view.
 * Replaces measureLayout/scrollTo when only web needs to be supported.
 */
export const scrollElementIntoView = (
  elementRef: RefObject<ViewInstance | null>,
  options?: ScrollIntoViewOptions,
) => {
  const element = elementRef.current as unknown as HTMLElement | null;

  element?.scrollIntoView({ behavior: 'smooth', block: 'start', ...options });
};
